import React from "react";

function PrivacyPolicy() {
  return (
    <section
      className="py-12"
      style={{
        backgroundColor: "var(--bg-color)",
        color: "var(--text-color)",
      }}
    >
      <div className="max-w-5xl mx-auto px-4">
        <h1
          className="text-3xl font-bold text-center mb-6"
          style={{ color: "var(--text-color)" }}
        >
          Privacy Policy
        </h1>

        <p className="mb-4 leading-relaxed">
          At <strong>CoursEngage</strong>, we are committed to safeguarding your
          privacy and ensuring that your personal information is protected. This
          Privacy Policy outlines how we collect, use, and protect your data when
          you interact with us online or through our services.
        </p>

        <h2
          className="text-xl font-semibold mb-2"
          style={{ color: "var(--text-color)" }}
        >
          1. Information We Collect
        </h2>
        <p className="mb-4 leading-relaxed">
          We collect personal information such as your name, email address, and
          password when you register or use our services.
        </p>

        <h2
          className="text-xl font-semibold mb-2"
          style={{ color: "var(--text-color)" }}
        >
          2. How We Use Your Information
        </h2>
        <p className="mb-4 leading-relaxed">
          Your personal information is used to provide you with our services,
          improve user experience, and communicate updates or offers. We do not
          share your personal data with third parties under any circumstances.
        </p>

        <h2
          className="text-xl font-semibold mb-2"
          style={{ color: "var(--text-color)" }}
        >
          3. Data Protection
        </h2>
        <p className="mb-4 leading-relaxed">
          We implement a variety of security measures to maintain the safety of your
          personal information. Your data is stored in secured networks, and
          access is limited to authorized personnel only.
        </p>

        <h2
          className="text-xl font-semibold mb-2"
          style={{ color: "var(--text-color)" }}
        >
          4. Your Rights
        </h2>
        <p className="mb-4 leading-relaxed">
          You have the right to access, modify, or delete your personal information
          at any time. If you choose to delete your account, all associated data
          will be permanently removed from our systems. For any questions
          regarding the management of your data, please contact us.
        </p>

        <h2
          className="text-xl font-semibold mb-2"
          style={{ color: "var(--text-color)" }}
        >
          5. Changes to This Policy
        </h2>
        <p className="mb-4 leading-relaxed">
          We may update this Privacy Policy periodically to reflect changes in our
          practices. Any updates will be posted on this page, and we encourage
          you to review our policy regularly.
        </p>

        <h2
          className="text-xl font-semibold mb-2"
          style={{ color: "var(--text-color)" }}
        >
          6. Contact Us
        </h2>
        <p className="mb-4 leading-relaxed">
          If you have any questions regarding this Privacy Policy, please contact us
          at <strong>info@coursengage.com</strong>.
        </p>
      </div>
    </section>
  );
}

export default PrivacyPolicy;
